import { render, staticRenderFns } from "./ExpenseError.vue?vue&type=template&id=ed351a3c&scoped=true&"
import script from "./ExpenseError.vue?vue&type=script&lang=js&"
export * from "./ExpenseError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed351a3c",
  null
  
)

export default component.exports